module.exports = __webpack_public_path__ + "static/media/logo_Tlb.d9a4fc91.png";